import React from 'react';
import ModalWithHeading from '../../components/ModalWithHeading';
import ServicesEstimate from './OrderSummary/ServicesEstimate';

export default function ServiceEstimateModal({ serviceEstimateModal, setServiceEstimateModal }) {
  return (
    <div>
      <ModalWithHeading
        modalOpen={serviceEstimateModal}
        setModalOpen={setServiceEstimateModal}
        title=''
        classes='max-w-3xl'
        closeBtn={true}
      >
        {serviceEstimateModal && <ServicesEstimate />}
      </ModalWithHeading>
    </div>
  );
}
